module.exports = __webpack_public_path__ + "img/service-242.f5d5c342.png";